import React, { useRef } from 'react'
import Slider from 'react-slick'
import { Box, Typography, Container, Button } from '@mui/material'
import Image from 'next/image'
import { ArrowForward } from '@mui/icons-material'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const PartnerRowSlider = ({ logos = [], direction = 'right', rowIndex }) => {
  const sliderRef = useRef(null)
  const settings = {
    infinite: true,
    speed: 7000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    pauseOnHover: false,
    draggable: true,
    swipe: true,
    touchMove: true,
    slidesToShow: 9,
    slidesToScroll: 1,
    rtl: direction === 'left',
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 6 } },
      { breakpoint: 960, settings: { slidesToShow: 4 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } }
    ]
  }

  const handleMouseDown = e => {
    e.target.style.cursor = 'grabbing'
  }

  const handleMouseUp = e => {
    e.target.style.cursor = 'grab'
  }

  return (
    <Box
      sx={{
        my: 4,
        '& .slick-list': {
          cursor: 'grab !important' // ensures pointer shows
        },
        '& .slick-slide': {
          display: 'flex',
          justifyContent: 'center'
        }
      }}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      ref={sliderRef}
    >
      <Slider {...settings}>
        {logos?.map((partner, index) => (
          <Box key={`${rowIndex}-${partner?._id || index}`} sx={{ px: 2 }}>
            <Box
              sx={{
                borderRadius: '50%',
                overflow: 'hidden',
                width: 80,
                height: 80,
                mx: 'auto',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Image
                src={`${process.env.IMAGE_BASE_URL}/${partner?.image}`}
                alt={partner?.name}
                width={70}
                height={70}
                style={{ objectFit: 'contain' }}
              />
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  )
}

const PartnerMultiRowCarousel = ({ logos = [], title, buttonTitle = '', handleEnquiryClick }) => {
  const chunkSize = Math.ceil(logos.length / 3)
  const rowChunks = [0, 1, 2].map(i =>
    logos.slice(i * chunkSize, (i + 1) * chunkSize)
  )

  return (
    <Box
      sx={{
        backgroundColor: '#1E1E1E',
        padding: '4rem 1rem',
        color: 'white',
        position: 'relative'
      }}
    >
      <Typography
        variant='h3'
        align='center'
        fontWeight={700}
        sx={{
          fontSize: {
            xs: '38px', // Small screens (mobile)
            sm: '38px', // Tablets
            md: '48px', // Medium devices
            lg: '48px' // Large screens
          }
        }}
      >
        RSL Trusted <span style={{ color: '#4adede' }}>Partners</span>

      </Typography>
      <Typography
        variant='body1'
        align='center'
        sx={{ mt: 2, maxWidth: 900, color: 'GrayText', mx: 'auto' }}
      >
        At RSL, we’re committed to your success. Through strong collaborations
        with our strategic partners, we provide the tools, support, and
        opportunities you need to reach your investment goals with confidence.
      </Typography>

      <Box
        sx={{
          mt: 4,
          position: 'relative', // Required for pseudo-elements
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            width: {
              xs: '10px', // Small screens (mobile)
              sm: '20px', // Tablets
              md: '130px', // Medium devices
              lg: '160px' // Large screens
            },
            height: '100%',
            zIndex: 3,
            pointerEvents: 'none',
            backdropFilter: 'blur(1px)'
          },
          '&::before': {
            left: 0,
            background: 'linear-gradient(to right, #1E1E1E, rgba(30,30,30,0))'
          },
          '&::after': {
            right: 0,
            background: 'linear-gradient(to left, #1E1E1E, rgba(30,30,30,0))'
          }
        }}
      >
        <PartnerRowSlider logos={rowChunks[0]} direction='right' rowIndex={1} />
        <PartnerRowSlider logos={rowChunks[1]} direction='left' rowIndex={2} />
        <PartnerRowSlider logos={rowChunks[2]} direction='right' rowIndex={3} />
      </Box>

      <Box textAlign='center' mt={4}>
        <Button
          variant='contained'
          size='large'
          endIcon={<ArrowForward />}
          sx={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 600,
            borderRadius: '12px',
            background: 'linear-gradient(to right, #9CD0C9, #32788E)',
            color: '#fff',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              background: 'linear-gradient(to right, #7BB9B2, #245E6E)',
              boxShadow: 'none'
            }
          }}
          onClick={handleEnquiryClick}
        >
          Join Now
        </Button>
      </Box>
    </Box>
  )
}

export default PartnerMultiRowCarousel
